// extracted by mini-css-extract-plugin
export default {"main":"InformedConsentPage_main__7Ux1g","content":"InformedConsentPage_content__GBLr2"};